import { render, staticRenderFns } from "./SalesPaymentGroup.vue?vue&type=template&id=317d06a5&"
import script from "./SalesPaymentGroup.vue?vue&type=script&lang=js&"
export * from "./SalesPaymentGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports